import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";



const FeedbackRow = ({ qusNo, qusLabel, value }) => {
    return (
        <View style={styles.rowContainer}>{/* Row */}
            <View style={[styles.leftPart, styles.border, styles.padding]}>
                <Text style={styles.text}>{qusNo ? (qusNo + ".  " + qusLabel) : qusLabel}</Text>
            </View>

            <View style={[styles.rightPart, styles.borderRight]}>
                    <View style={styles.imageRow}>
                        <View style={styles.imageContainer}>
                            <Image style={[value == 10 ? styles.sel_resource_img : styles.resource_img]} src={"https://sms.cooledsys.com/emo1.png"} />
                        </View>
                        <View style={styles.imageContainer}>
                            <Image style={[value == 20 ? styles.sel_resource_img : styles.resource_img]} src={"https://sms.cooledsys.com/emo2.png"} />
                        </View>
                        <View style={styles.imageContainer}>
                            <Image style={[value == 30 ? styles.sel_resource_img : styles.resource_img]} src={"https://sms.cooledsys.com/emo3.png"} />
                        </View>
                        <View style={styles.imageContainer}>
                            <Image style={[value == 40 ? styles.sel_resource_img : styles.resource_img]} src={"https://sms.cooledsys.com/emo4.png"} />
                        </View>
                    </View>
                    <View style={styles.labelRow}>
                        <View style={styles.labelContainer}><Text style={styles.labelText}>Yes</Text></View>
                        <View style={styles.labelContainer}><Text style={styles.labelText}>Sometimes</Text></View>
                        <View style={styles.labelContainer}><Text style={styles.labelText}>No</Text></View>
                        <View style={styles.labelContainer}><Text style={styles.labelText}>Not Sure</Text></View>
                    </View>
            </View>
        </View>
    )
}

export default FeedbackRow;

const styles = StyleSheet.create({
    rowContainer: {
        flexDirection: 'row',
        height: 80,
    },
    leftPart: {
        flex: 1,
        flexDirection: "column",
        justifyContent:"center",
    },
    rightPart: {
        flex: 1,
        flexDirection: "column", 
        justifyContent:"center"
    },
    border: {
        border: '1px solid darkorange',
        borderTop: 'none'
    },
    borderLeft: {
        border: '1px solid darkorange',
        borderTop: 'none',
        borderLeft: 'none'
    },
    borderRight: {
        border: '1px solid darkorange',
        borderTop: 'none',
        borderLeft: 'none'
    },
    padding: {
        padding: 10
    },
    text: {
        fontSize:12,
        width: '100%',
        lineHeight: '1.4'
    },
    columnContainer: {
        flex: 1,
        flexDirection: 'column'
    },
    imageRow: {
        flex: 3,
        margin: 5,
        flexDirection: 'row',
        // justifyContent:"center",
        // border: '1px solid black',
    },
    imageContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    labelRow: {
        flex: 1,
        backgroundColor: '#fde9d9',
        borderTop: '1px solid darkorange',
        marginBottom: 0,
        flexDirection: 'row'
    },
    labelContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    labelText: {
        textAlign: 'center',
        fontSize: 10
    },
    sel_resource_img: {
        width: 50,
        height: 50,
        objectFit: 'contain',
        borderRadius: 4,
        border: '2px solid orange',
        padding: 5
    },
    resource_img: {
        width: 50,
        height: 50,
        objectFit: 'contain',
        borderRadius: 4,
        border: '1px solid grey',
        opacity: .4,
        padding: 5
    }
});
